import { createFileRoute } from "@tanstack/react-router";
import { SettingsThisDevice } from "@/screens/ParentSettingsSections";
// MA-861: the "This device" section (device mode, reduce motion, high
// contrast, narration speed). It keeps the old Accessibility path.
export const Route = createFileRoute("/parent/settings/accessibility")({ component: SettingsThisDevice });
